import antd from 'ant-design-vue/es/locale-provider/th_TH';
import dayjsLocale from 'dayjs/locale/th';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/th.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'th',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
